import { Link } from 'react-router-dom';
import { categories } from '@/mocks/siteData';

export default function CategoryGrid() {
  return (
    <section className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
            漫画分类导览
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            六大分类专区，满足不同口味需求。点击任意分类开始探索精彩漫画世界。
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group relative rounded-lg overflow-hidden bg-background-100 hover:bg-background-200/70 transition-all duration-300 p-6 md:p-8"
            >
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600 group-hover:bg-primary-500 group-hover:text-white transition-all duration-300 flex-shrink-0">
                  <i className={`${cat.icon} text-xl md:text-2xl`}></i>
                </div>
                <div className="flex-1 min-w-0">
                  <h3 className="text-lg md:text-xl font-heading font-semibold text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors">
                    {cat.name}
                  </h3>
                  <p className="text-sm text-foreground-600 leading-relaxed">
                    {cat.description}
                  </p>
                </div>
                <div className="w-8 h-8 flex items-center justify-center flex-shrink-0 text-foreground-300 group-hover:text-primary-500 group-hover:translate-x-1 transition-all duration-300">
                  <i className="ri-arrow-right-line text-lg"></i>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}